export default [
  {
    email: 'pedro@autonomia.digital',
  },
  {
    email: 'cristina@autonomia.digital',
  },
];
